import Axois from '../utils/axios'
import EventEmitter from "../../utils/eventEmitter";



export const loadPackages = async () => {
  let response = await Axois.get('/packages').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
  // return [];
}


export const loadPackage = async (action) => {
  try {
    switch (action) {
      case 'new':
        let requests = await Axois.get('/setups/packages');
        const responseData = await requests.data;
        return {...responseData, packageProduct: {}};
        // return { positions: [], budgets: [], analytic: {}};
      
      default:
        let response = await Axois.get('/packages/'+action);
        const responseJson = await response.data;
        return responseJson;
        // return { positions: [], budgets: [], analytic: {}};
    }
  }catch (err) {
    console.log(err);
  }
}



const usePackagesAPI = () => {
  
  const create = async (data, success) => {
    try {
      const response = await Axois.post('/packages', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('package_created', data.seo);
    }catch(err) {
      console.log(err);
    }
  };


  const update = async (seo, data, success) => {
    try {
      const response = await Axois.put('/packages/'+seo, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('package_updated', data.seo);
    }catch (err) {
      console.log(err);
    }
  }

  return { create, update };
}


export default usePackagesAPI;